import './styles/graphic.scss';

// Import the JSON data (pulled from Google Sheets "data" tab)
import data from './data/data.json';

// Import images
import vanceImg from './img/processed/use/vance.png';
import newsomImg from './img/processed/use/newsom.png';
import harrisImg from './img/processed/use/harris.png';
import rubioImg from './img/processed/use/rubio.png';
import aocImg from './img/processed/use/ocasio-cortez.png';
import noCandImg from './img/processed/use/no-cand.png';

// Image map based on last name (or first name for "No person in mind")
const imageMap = {
  Vance: vanceImg,
  Newsom: newsomImg,
  Harris: harrisImg,
  Rubio: rubioImg,
  'Ocasio-Cortez': aocImg,
  'No person in mind': noCandImg,
};

// Party colors
const partyColors = {
  R: '#E06969',
  D: '#244C8D',
  '': '#6E6E6E',
  NA: '#6E6E6E',
};

export default function (props, container, isMobile) {
  // Create the cards container
  const cardsContainer = container.append('div')
    .attr('class', 'cards-container');

  // Create a card for each candidate
  data.forEach((candidate) => {
    const party = candidate.party || '';
    const partyColor = partyColors[party] || partyColors[''];
    const firstName = (candidate.first_name || '').trim();
    const lastName = (candidate.last_name || '').trim();
    const image = imageMap[lastName] || imageMap[firstName];
    const isAOC = lastName === 'Ocasio-Cortez';
    const fullName = lastName ? `${firstName} ${lastName}` : firstName;

    // Card wrapper
    const card = cardsContainer.append('div')
      .attr('class', 'card');

    // Top border color
    card.append('div')
      .attr('class', 'card-border')
      .style('background-color', partyColor);

    // Card content
    const cardContent = card.append('div')
      .attr('class', 'card-content');

    // Header section (image + name/percent)
    const header = cardContent.append('div')
      .attr('class', 'card-header');

    // Circular image container
    const imageContainer = header.append('div')
      .attr('class', 'image-container');

    if (image) {
      imageContainer.append('img')
        .attr('src', image)
        .attr('alt', fullName);
    }

    // Name and percent section
    const info = header.append('div')
      .attr('class', 'candidate-info');

    // Name with party
    const nameContainer = info.append('div')
      .attr('class', 'name-container');

    if (isAOC) {
      // AOC gets her name on two lines
      nameContainer.append('span')
        .attr('class', 'candidate-name')
        .text(firstName);
      nameContainer.append('br');
      nameContainer.append('span')
        .attr('class', 'candidate-name')
        .text(`${lastName} `);
      if (party) {
        nameContainer.append('span')
          .attr('class', 'party-label')
          .style('color', partyColor)
          .text(`(${party})`);
      }
    } else {
      nameContainer.append('span')
        .attr('class', 'candidate-name')
        .text(`${fullName} `);
      if (party) {
        nameContainer.append('span')
          .attr('class', 'party-label')
          .style('color', partyColor)
          .text(`(${party})`);
      }
    }

    // Percent who said
    info.append('div')
      .attr('class', 'percent-line')
      .html(`Percent who said: <span class="percent-value">${candidate.respondents_pct}%</span>`);

    // Reasons section
    const reasons = cardContent.append('div')
      .attr('class', 'reasons-section');

    const isNoSpecificPerson = firstName === 'No person in mind';
    reasons.append('div')
      .attr('class', 'reasons-label')
      .text(isNoSpecificPerson ? 'Most important traits:' : 'Top reasons for support:');

    const list = reasons.append('ul')
      .attr('class', 'reasons-list');

    [candidate.top_trait1, candidate.top_trait2, candidate.top_trait3].forEach((trait) => {
      if (trait) {
        // Add word break opportunities after slashes for mobile wrapping
        const formattedTrait = trait.trim().replace(/\//g, '/<wbr>');
        list.append('li').html(formattedTrait);
      }
    });
  });
}
